import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, trackCheckout } from '../utils/checkout';
const proofPoints = ['6 Complete Teaching Volumes', '120 Ready-to-Teach Swimming Lessons', '5 Premium Bonus Guides', 'Instant Digital Access', 'PDF Format — Ready to Use'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-ivory" data-id="element-148" data-mp="129qv5nkuztox">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-149" data-mp="xanra6gm7tij">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-150" data-mp="sbb23f29uacs">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/60 bg-gold/10 text-navy font-semibold text-[10px] sm:text-sm tracking-[0.18em] uppercase whitespace-nowrap mb-4 sm:mb-6" data-id="element-151" data-mp="3d1a8hk3o4bda">
            Swim Instructor Ready
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6 text-navy" data-id="element-152" data-mp="3j924lm8avmuh">
            Solve an Entire Year of Swim Lessons in Just{' '}
            <span className="text-gold-dark" data-id="element-153" data-mp="399tex5kgwudx">5 MINUTES</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full max-w-[340px] sm:max-w-lg md:max-w-2xl mb-4 sm:mb-6" data-id="element-154" data-mp="3e84rho25dizu">
          <div className="absolute inset-8 rounded-full bg-aqua/10 blur-3xl" aria-hidden="true" data-id="element-155" data-mp="2ql6a8o67e70v" />
          <img src="https://cdn.magicpatterns.com/uploads/5A9SKZJM71kufKQYn8FawU/Diseno_sin_titulo_(62).png" alt="Swim Instructor Ready — complete 6-volume teaching system with 120 ready-to-teach swimming lessons and 5 bonus guides" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-156" data-mp="2vjpywwc6lwwx" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-157" data-mp="nbl4gqm0mqd3">
          <p className="text-sm sm:text-lg md:text-xl text-graphite leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-158" data-mp="ddwwv03b9odi">
            Swim Instructor Ready — 120 ready-to-teach swimming lessons inside a complete
            6-in-1 teaching system designed for swim instructors who want to plan less, teach
            with confidence, and know exactly how to progress every swimmer.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-159" data-mp="x1nwanhehy9u">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 text-center" data-id="element-160" data-mp="x37bearbm3a1">
              GET THE COMPLETE 6-IN-1 SWIM TEACHING SYSTEM TODAY
            </Button>
          </div>

          <ul className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-graphite" data-id="element-161" data-mp="1x7hw9eyk651e">
            {proofPoints.map(point => <li key={point} className="flex items-center gap-1.5" data-id="element-162" data-mp="268y4ph5tbx2z">
                <CheckIcon size={14} className="text-aqua-dark shrink-0" data-id="element-163" data-mp="2b0fynl9f4xeg" />
                <span data-id="element-164" data-mp="2b2kb4rldv4qc">{point}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}